// Strict loading: disable the automatic Klaviyo embed and use Consentmo's public API.
// Keep the existing product event contract used by Browse Abandonment flows.
(function () {
  'use strict';
  var loaded = false;
  var sent = false;
  var resetting = false;
  var privacyRequested = false;
  function ensurePrivacyReady() {
    var shopify = window.Shopify;
    if (privacyRequested || !shopify || shopify.customerPrivacy || typeof shopify.loadFeatures !== 'function') return;
    privacyRequested = true;
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) update();
    });
  }
  function allowed() {
    var cmp = window.Consentmo;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cmp && typeof cmp.marketingAllowed === 'function' && cmp.marketingAllowed() === true
      && privacy && typeof privacy.saleOfDataAllowed === 'function' && privacy.saleOfDataAllowed() === true);
  }
  function viewedProduct() {
    if (sent || resetting || !allowed()) return;
    var element = document.getElementById('consentmo-klaviyo-product');
    if (!element) return;
    var item;
    try { item = JSON.parse(element.textContent); } catch (error) { return; }
    item.Value = Number(item.Value).toFixed(2);
    var viewedItem = { Title: item.Name, ItemId: item.ProductID, Categories: item.Categories,
      ImageUrl: item.ImageURL, Url: item.URL,
      Metadata: { Brand: item.Brand, Price: item.Price, CompareAtPrice: item.CompareAtPrice } };
    sent = true;
    var kl = window.klaviyo;
    if (kl && !Array.isArray(kl) && typeof kl.track === 'function' && typeof kl.trackViewedItem === 'function') {
      kl.track('Viewed Product', item);
      kl.trackViewedItem(viewedItem);
    } else {
      var queue = window._learnq = window._learnq || [];
      queue.push(['track', 'Viewed Product', item]);
      queue.push(['trackViewedItem', viewedItem]);
    }
  }
  // Outside the consent regions Consentmo fires consentmoSignal_onLoad before window.Consentmo exists and
  // sends no later signal, so re-check once the API appears (bounded: 240 x 250 ms).
  var waiting = false;
  function waitForConsentmo() {
    if (waiting || window.Consentmo || typeof window.setInterval !== 'function') return;
    waiting = true;
    var tries = 0;
    var id = window.setInterval(function () {
      tries += 1;
      if (!window.Consentmo && tries < 240) return;
      window.clearInterval(id);
      waiting = false;
      if (window.Consentmo) update();
    }, 250);
  }
  function update() {
    ensurePrivacyReady();
    if (!window.Consentmo) {
      waitForConsentmo();
      return;
    }
    if (!allowed()) {
      if (loaded && !resetting) {
        resetting = true;
        window.location.reload();
      }
      return;
    }
    if (loaded || resetting) return;
    loaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/RmdNXZ/klaviyo.js?company_id=RmdNXZ';
    script.onload = viewedProduct;
    document.head.appendChild(script);
  }
  document.addEventListener('consentmoSignal_onLoad', update);
  document.addEventListener('consentmoSignal', update);
  document.addEventListener('visitorConsentCollected', update);
  update();
})();
